import * as React from 'react';

export interface INoResultsSpecificProps {
    message: string;
    action?: () => void;
    className?: string;
    testRoleMainPart?: string;
}



export const NoResultsEmptyList: React.FC<INoResultsSpecificProps> = (props) => {
    return <NoResultsCustom {...props} testRole={props.testRoleMainPart ? `${props.testRoleMainPart}--empty` : undefined} />
}

export const NoResultsLoginNeeded: React.FC<INoResultsSpecificProps> = (props) => {
    return <NoResultsCustom {...props} testRole={props.testRoleMainPart ? `${props.testRoleMainPart}--need-login` : undefined} />
}


export interface INoResultsCustomProps {
    message: string;
    action?: () => void;
    className?: string;
    testRole?: string;
}


export const NoResultsCustom: React.FC<INoResultsCustomProps> = (props) => {
    return <div className={props.className ? props.className : "p-2"} data-test-role={props.testRole}>{props.message} {props.children}</div> /* TODO or button with text and action in props? */
}